(function () {
    'use strict';

    angular.module('app.charts')
        .directive('columnChart', columnChart);

    /* @ngInject */
    function columnChart(SETTINGS, DataFactory, Charts) {
        return {
            restrict: 'E',
            template: '<div class="chart-header"><div><h3 class="chart-title">{{chartTitle}}<span class="sub">{{subtitle}}</span></h3></div><i class="icon-cloud-download" ng-click="exportChart()" title="Download chart"></i><i class="icon-doc" ng-if="chartDataKey" ng-click="downloadData()" title="Download data"></i></div><div ng-if="noData" class="chart-no-data">{{noDataMessage}}</div><div ng-if="!noData" class="cl-chart cl-chart-serial" id="{{id}}_chart"></div><p ng-if="source && !hideSource && !noData" class="source">Source: {{source}}​</p>',
            scope: {
                id: '@',
                autoWrap: '=',
                chartData: '=',
                chartDataKey: '@',
                unit: '@',
                yLabel: '=',
                yLabelRotation: '=',
                showLabels: "=",
                chartTitle: '@',
                subtitle: '@',
                note: '@',
                source: '@',
                logoUrl: '@',
                balloonText: '=',
                minValue: '=',
                maxValue: "=",
                hideLegend: '=',
                disableToggle: '=',
                showValueAxisUnit: '@',
                showBalloon: '=',
                fixedColumnWidth: '=',
                legendLabelWidth: '=',
                legendPosition: "@",
                legendReverse: "@",
                colors: '=',
                highlightedItem: '=',
                labelRotation: '=',
                labelOffset: '=',
                valuePosition: '@',
                stack: '@', // [regular|100%]
                hideSource: '=',
                precision: '=',
                noDataMessage: '@',
                exportLabel: '=' // text to add to exported images
            },
            link: link
        };

        function link(scope, elm, attrs) {

            var chart,
                hiddenChart,
                hiddenID = scope.id + '_hidden',
                exportW = 1200,
                exportH = 800,
                hasOneSeries = true,
                hideValueAxis = !!scope.hideValueAxis,
                showValueAxisUnit = !!scope.showValueAxisUnit,
                stackType = 'none',
                valuePosition,
                hideLegend = false,
                showLabels = true,
                showBalloon = true,
                yLabelRotation = 0,
                labelText = '',
                labelRotation = 0,
                labelReverse = true,
                fixedColumnWidth = false,
                disableToggle = false,
                legendLabelWidth = false,
                labelOffset = 2,
                balloonText,
                autoWrap = true,
                note = '',
                minValue,
                maxValue,
                legendPosition = 'right',
                legendReverse = false,
                legendAlign = '',
                legendLeft = undefined,
                legendRight = undefined,
                legendTop = undefined,
                legendBottom = undefined,
                legendWidth = undefined,
                unit = '',
                unitPosition = '',
                source = SETTINGS.CHARTS.SOURCE,
                colors = SETTINGS.PALETTE,
                precision = SETTINGS.CHARTS.PRECISION
            ;

            if (scope.id === undefined) {
                console.log('id must be set')
            }

            if (angular.isUndefined(scope.valuePosition)) {
                valuePosition = 'hover';
            }

            if (angular.isDefined(scope.unit)) {
                unit = scope.unit;
                if (unit === "$") {
                    precision = SETTINGS.CHARTS.DOLLARPRECISION;
                    if (unitPosition === '') {
                        unitPosition = 'left';
                    }
                }
            }

            if (angular.isDefined(scope.autoWrap)) {
                autoWrap = scope.autoWrap;
            }

            if (angular.isDefined(scope.showLabels)) {
                showLabels = !!scope.showLabels;
            }

            if (angular.isDefined(scope.showBalloon)) {
                showBalloon = !!scope.showBalloon;
            }

            if (angular.isDefined(scope.balloonText)) {
                balloonText = scope.balloonText;
            }

            if (angular.isDefined(scope.legendLabelWidth)) {
                legendLabelWidth = scope.legendLabelWidth;
            }

            if (angular.isDefined(scope.fixedColumnWidth)) {
                fixedColumnWidth = scope.fixedColumnWidth;
            }

            if (angular.isDefined(scope.hideLegend)) {
                hideLegend = scope.hideLegend;
            }

            if (angular.isDefined(scope.disableToggle)) {
                disableToggle = scope.disableToggle;
            }

            if (angular.isDefined(scope.minValue)) {
                minValue = scope.minValue;
            }

            if (angular.isDefined(scope.maxValue)) {
                maxValue = scope.maxValue;
            }

            if (angular.isDefined(scope.legendPosition)) {

                legendPosition = scope.legendPosition;

                // Check for coords
                var coords = legendPosition.split(',');
                if (coords.length === 2) {
                    legendPosition = 'absolute';
                    legendWidth = 200; // stops the legend getting too wide and hence limits change per screen size - not well tested, might be better as an explicit setting

                    var x = coords[0], y = coords[1];

                    // x
                    if (x.substr(0, 1) === '-') { // locate from the right if negative (inc -0)
                        legendAlign = 'right';
                        legendRight = x * -1;
                    } else {
                        legendLeft = x;
                    }

                    // y
                    if (y.substr(0, 1) === '-') {
                        legendBottom = y * -1;
                    } else {
                        legendTop = y;
                    }

                } else if (legendPosition === 'bottom' && legendAlign === '') {
                    legendAlign = 'center';
                }
            }

            if (angular.isDefined(scope.legendReverse)) {
                legendReverse = scope.legendReverse;
            }

            if (angular.isDefined(scope.yLabelRotation)) {
                yLabelRotation = scope.yLabelRotation;
            }

            if (angular.isDefined(scope.labelRotation)) {
                labelRotation = scope.labelRotation;
            }

            if (angular.isDefined(scope.labelOffset)) {
                labelOffset = scope.labelOffset;
            }

            if (angular.isDefined(scope.colors)) {
                colors = scope.colors;
            }

            if (angular.isDefined(scope.logoUrl)) {
                $(elm).children('.chart-header').prepend('<div><img class="logo" src="' + scope.logoUrl + '" /></div>');
            }

            if (angular.isDefined(scope.stack)) {
                stackType = scope.stack;
            }

            if (angular.isDefined(scope.precision)) {
                precision = parseInt(scope.precision, 10);
                if (angular.isDefined(scope.unit) && scope.unit === "$") {
                    precision = SETTINGS.CHARTS.DOLLARPRECISION;
                }
            }

            if (!angular.isDefined(scope.noDataMessage)) {
                scope.noDataMessage = 'Data not available for this chart';
            }

            elm.append('<div class="chart-hidden" id="' + hiddenID + '"></div>');

            scope.$watch('chartData', function (newVal) {
                if (angular.isArray(newVal) && newVal.length > 0) {

                    if (angular.isDefined(scope.highlightColor) && angular.isDefined(scope.highlightedItem)) {
                        // apply custom highlight color
                        angular.forEach(newVal, function (value, key) {
                            if (value.Category === scope.highlightedItem) {
                                value.color = scope.highlightColor;
                            } else {
                                value.color = colors[0];
                            }
                        });
                    }

                    if (angular.isDefined(scope.source)) {
                        source = scope.source;
                    }

                    render();
                    chart.dataProvider = newVal;

                    // Set value axis properties
                    angular.forEach(chart.valueAxes, function (va) {
                        va.unit = unit;
                        va.unitPosition = unitPosition;
                        va.title = scope.yLabel;
                    });
                }
            });

            function render() {

                if (window.screen.width < 500) {
                    legendPosition = "bottom";
                    if (window.screen.width < 430) {
                        yLabelRotation = 70
                    }
                }

                var config = {
                    type: 'serial',
                    sequencedAnimation: false,
                    categoryField: 'Category',
                    colors: colors,
                    startDuration: .4,
                    categoryAxis: {
                        title: '',
                        axisColor: 'transparent', // hide ugly horizontal line which shows when chart has negative values
                        color: SETTINGS.CHARTS.TEXT.COLOR,
                        gridThickness: 0,
                        minHorizontalGap: 0,
                        autoWrap: autoWrap,
                        labelRotation: yLabelRotation
                    },
                    minMarginBottom: 70, // stops wrapped category axis labels getting chopped
                    graphs: graphs(),
                    precision: precision,
                    balloon: {
                        fixedPosition: false
                    },
                    valueAxes: [
                        {
                            stackType: stackType,
                            gridThickness: 0,
                            title: hideValueAxis ? '' : scope.yLabel,
                            unit: showValueAxisUnit ? unit : '',
                            unitPosition: unitPosition,
                            axisColor: '#E5E5E5',
                            color: SETTINGS.CHARTS.TEXT.COLOR,
                            tickLength: hideValueAxis ? 0 : 5,
                            labelsEnabled: !hideValueAxis,
                            axisThickness: hideValueAxis ? 0 : 1,
                            showFirstLabel: false,
                            showLastLabel: false,
                            minimum: minValue,
                            maximum: maxValue
                        }
                    ],
                    titles: [],
                    legend: {
                        enabled: !hasOneSeries && !hideLegend,
                        useGraphSettings: true,
                        position: legendPosition,
                        reversedOrder: legendReverse,
                        align: legendAlign,
                        forceWidth: true,
                        labelWidth: legendLabelWidth,
                        switchable: SETTINGS.CHARTS.LEGEND.SWITCHABLE,
                        left: legendLeft,
                        right: legendRight,
                        top: legendTop,
                        bottom: legendBottom,
                        width: legendWidth
                    },

                    dataProvider: scope.chartData
                };

                //Set axis min to zero if minimum value positive
                if (angular.isUndefined(scope.minValue)) {
                    var dataMin = config.dataProvider[0].value;

                    angular.forEach(config.dataProvider, function (value, key) {
                        if (value.value < dataMin) {
                            dataMin = value.value
                        }
                    });

                    if (dataMin > 0) {
                        config.valueAxes[0].minimum = 0
                    }

                }


                if (angular.isDefined(scope.note)) {
                    config.marginTop = 20;
                    config['allLabels'] = [
                        {
                            "text": scope.note,
                            "bold": false,
                            "align": "center",
                            "size": 14,
                            "y": 0
                        }
                    ]
                }

                chart = AmCharts.makeChart(scope.id + "_chart", config, 100);

                if (disableToggle) {
                    // add chart events after chart is inited
                    chart.addListener("init", function (event) {
                        // launch this after item is hidden in the legend
                        chart.legend.addListener("hideItem", function (event) {
                            // if the graph has custom parameter "disableToggle" set, immediatelly show it back
                            if (event.dataItem.disableToggle) {
                                chart.showGraph(event.dataItem);
                            }
                        });
                    });
                }


                function graphs() {

                    var graphs = [];

                    // Get the graphs by looking at the first data point
                    angular.forEach(scope.chartData[0], function (x, title) {
                        if (title === 'Category' || title === 'AdditionalData' || title === 'color' || title === 'labelColor') {
                            return;
                        }


                        var this_graph = {
                            "fillAlphas": 1,
                            "title": title,
                            "type": "column",
                            "valueField": title,
                            "color": '#ffffff',
                            "showBalloon": showBalloon,
                            "showAllValueLabels": true,
                            "labelRotation": labelRotation,
                            "labelOffset": labelOffset,
                            "labelColorField": 'labelColor',
                            "labelText": showLabels ?  '[[value]]' + unit : '',
                            "labelFunction": function (item) {
                                var result = '';
                                if (!isNaN(item.values.value)) {
                                    var formatted = AmCharts.formatNumber(item.values.value, {
                                        precision: precision,
                                        decimalSeparator: chart.decimalSeparator,
                                        thousandsSeparator: chart.thousandsSeparator
                                    }, precision);
                                    result += formatted;

                                    if (unit !== '') {
                                        if (unitPosition === 'left') {
                                            result = unit + result;
                                        } else {
                                            result += unit;
                                        }
                                    }
                                }
                                return result;
                            },
                            "disableToggle": disableToggle,
                            "fontSize": 10,
                            "balloonText": angular.isDefined(balloonText) ? balloonText : title + " : [[value]]",
                            "balloonFunction": function (item, graph) {
                                var result = graph.balloonText;
                                if (!isNaN(item.values.value)) {
                                    var formatted = AmCharts.formatNumber(item.values.value, {
                                        precision: precision,
                                        decimalSeparator: chart.decimalSeparator,
                                        thousandsSeparator: chart.thousandsSeparator
                                    }, precision);

                                    if (unit !== '') {
                                        if (unitPosition === 'left') {
                                            result = result.replace('[[value]]', unit + formatted);
                                        } else {
                                            result = result.replace('[[value]]', formatted + unit);
                                        }
                                    } else {
                                        result = result.replace('[[value]]', formatted);
                                    }

                                    if (result.includes('[[category]]')) {
                                        result = result.replace('[[category]]', item.category);

                                    }
                                }
                                return result;
                            }
                        };

                        if (fixedColumnWidth > 0) {
                            this_graph["fixedColumnWidth"] = fixedColumnWidth
                        }

                        if (fixedColumnWidth > 0) {
                            this_graph["fixedColumnWidth"] = fixedColumnWidth
                        }


                        graphs.push(this_graph);
                    });

                    hasOneSeries = graphs.length === 1;

                    return graphs;
                }

                function exportChart() {

                    var exportConfig = {};

                    var hiddenDiv = angular.element(document.getElementById(hiddenID));
                    hiddenDiv.css({
                        width: exportW + 'px',
                        height: exportH + 'px'
                    });

                    // Copy visible chart config
                    angular.copy(config, exportConfig);

                    angular.forEach(exportConfig.graphs, function (graph) {
                        graph["labelText"] = "[[value]]" + unit;
                        graph["labelFunction"] = function (item) {
                            var result = '';
                            if (!isNaN(item.values.value)) {
                                result += AmCharts.formatNumber(item.values.value, {
                                    precision: precision,
                                    decimalSeparator: chart.decimalSeparator,
                                    thousandsSeparator: chart.thousandsSeparator
                                }, precision);

                                if (unit !== '') {
                                    if (unitPosition === 'left') {
                                        result = unit + result;
                                    } else {
                                        result += unit;
                                    }
                                }
                            }
                            return result;
                        }
                    });

                    exportConfig.categoryAxis.labelRotation = 0;
                    exportConfig.categoryAxis.autoWrap = true;

                    exportConfig.autoMargins = false;
                    exportConfig.marginLeft = 100;
                    exportConfig.marginTop = 50;
                    exportConfig.marginBottom = 100;

                    // Update data
                    exportConfig.dataProvider = scope.chartData;

                    if (angular.isDefined(scope.chartTitle)) {
                        exportConfig.marginTop += 50;
                    }

                    if (angular.isDefined(scope.subtitle)) {
                        exportConfig.marginTop += 30;
                    }

                    if (exportConfig.legend.position === 'bottom') {
                        exportConfig.legend.autoMargins = false;
                        exportConfig.legend.marginBottom = 70;
                    } else {
                        if (angular.isDefined(scope.footer)) {
                            exportConfig.marginBottom += 50;
                        }
                    }

                    exportConfig.export = {
                        enabled: true,
                        libs: {
                            autoLoad: false
                        },
                        menu: [],
                        afterCapture: function () {
                            var instance = this;

                            // Header rect
                            var headerRect = new fabric.Rect({
                                top: 10,
                                left: 0,
                                width: exportW,
                                height: 5,
                                fill: '#e4e8eb'
                            });
                            instance.setup.fabric.add(headerRect);

                            // Logo
                            var imgEl = document.querySelector('#chart-header-img');
                            if (imgEl !== null) {
                                var logo = new fabric.Image(imgEl, {
                                    left: exportW - imgEl.width - 40,
                                    top: 15
                                });
                                instance.setup.fabric.add(logo);
                            }

                            var xPos = 30, yPos = 35;

                            // Export label
                            if (angular.isDefined(scope.exportLabel)) {
                                var label = new fabric.Text(scope.exportLabel, {
                                    left: xPos,
                                    top: yPos,
                                    fontFamily: SETTINGS.FONT_FAMILY,
                                    fontSize: 18,
                                    fontWeight: 700
                                });
                                instance.setup.fabric.add(label);
                                yPos += 20;
                            }

                            // Title
                            if (angular.isDefined(scope.chartTitle)) {
                                var title = new fabric.Text(scope.chartTitle.toUpperCase(), {
                                    left: xPos,
                                    top: 40,
                                    fontFamily: SETTINGS.FONT_FAMILY,
                                    fontSize: 18
                                });
                                title.left = 30;
                                instance.setup.fabric.add(title);
                            }

                            // Subtitle
                            if (angular.isDefined(scope.subtitle)) {
                                var subtitle = new fabric.Text(scope.subtitle, {
                                    left: xPos,
                                    top: yPos,
                                    fontFamily: SETTINGS.FONT_FAMILY,
                                    fontSize: 15
                                });
                                subtitle.left = exportW / 2 - subtitle.width / 2;
                                instance.setup.fabric.add(subtitle);
                            }

                            // Footer
                            if (scope.footer) {
                                var footer = new fabric.Text(scope.footer, {
                                    left: xPos,
                                    top: exportH - 50,
                                    fontFamily: SETTINGS.FONT_FAMILY,
                                    fontSize: 10
                                });
                                instance.setup.fabric.add(footer);
                            }

                            // Source
                            var src = new fabric.Text('Source: ' + source, {
                                left: xPos,
                                top: exportH - 60,
                                fontFamily: SETTINGS.FONT_FAMILY,
                                fontSize: 10
                            });
                            instance.setup.fabric.add(src);

                            // Copyright text
                            var footerText = new fabric.Text('Copyright © 2018 The Nielsen Company', {
                                left: xPos,
                                top: exportH - 38,
                                fontFamily: SETTINGS.FONT_FAMILY,
                                fontSize: 10
                            });
                            instance.setup.fabric.add(footerText);

                            // Footer rect
                            var footerRect = new fabric.Rect({
                                top: exportH - 15,
                                left: 0,
                                width: exportW,
                                height: 5,
                                fill: '#e4e8eb'
                            });
                            instance.setup.fabric.add(footerRect);
                        }
                    };

                    hiddenChart = AmCharts.makeChart(hiddenID, exportConfig);

                    hiddenChart.export.capture({}, function () {
                        this.toPNG({multiplier: 2}, function (data) {
                            this.download(data, this.defaults.formats.PNG.mimeType, scope.chartTitle);
                        });
                    });
                }

                scope.exportChart = exportChart;

                function downloadData() {
                    if (angular.isDefined(scope.chartDataKey)) {
                        DataFactory.download(scope.chartDataKey, scope.chartTitle);
                    }
                }

                scope.downloadData = downloadData;
            }
        }
    }
})();
